import { useTheme } from '@emotion/react';

import * as styles from './pagination.styles';

type Props = {
  type: 'before' | 'after';
  page: number;
  pagesTotal?: number;
};

export const PaginationDivider = ({ type, page, pagesTotal = 0 }: Props) => {
  const theme = useTheme();

  const beforeThreshold = 3;
  const afterThreshold = 2;

  if (type === 'before' && page <= beforeThreshold) {
    return null;
  }

  if (type === 'after' && page >= pagesTotal - afterThreshold) {
    return null;
  }

  return (
    <div
      css={[styles.item(theme), styles.dotSpaces]}
      data-testid="pagination-divider"
      // eslint-disable-next-line react/jsx-no-literals
    >
      …
    </div>
  );
};
